import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { from, Observable, of, switchMap } from 'rxjs';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { AppConstants } from '../../app-constants';
import { DEMO_MODULE } from 'src/app/utils/demo-mode/demo-mode-context.util';
import { DemoModeHelper } from 'src/app/utils/demo-mode/demo-mode-helper.util';
import { DemoModuleService } from 'src/app/services/demo-mode/demo-module.service'

@Injectable()
export class DemoModeInterceptor implements HttpInterceptor {

  constructor(
      private featureFlagsService: FeatureFlagsService,
      private demoModuleService: DemoModuleService
    ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const moduleName = req.context.get(DEMO_MODULE);

    return from(this.featureFlagsService.isFlagEnabled(AppConstants.DEMO_MODE)).pipe(
      switchMap(isDemoEnabledFlag => {
        if (!moduleName || !isDemoEnabledFlag) {
          return next.handle(req);
        }
        
        const demoModules = [
          AppConstants.LEADERBOARD_UI,
          AppConstants.NEW_REPORTING_UI
        ];
        const isDemoModule = demoModules.includes(moduleName);
        if (!isDemoModule) {
          return next.handle(req);
        }

        const urlPath = req.url.split('?')[0];
        const queryParams = DemoModeHelper.getQueryParamsFromUrl(req.url);
        const demoDataConfig = this.demoModuleService.getDemoConfig(moduleName, urlPath);

        if (!demoDataConfig || !demoDataConfig.data || !demoDataConfig.matchedKey) {
          return next.handle(req);
        }

        const { data: mockData, normalize, matchedKey } = demoDataConfig;
        const dataArray = Array.isArray(mockData) ? mockData : [mockData];
        let requestData = req.body ?? (Object.keys(queryParams).length ? queryParams : null);
        
        if (moduleName === AppConstants.LEADERBOARD_UI) {
          requestData = DemoModeHelper.removeAccountUuidFromRequestBody(requestData);
        }

        let finalData = requestData
          ? DemoModeHelper.filterDemoDataByRequest(dataArray, requestData, matchedKey)
          : mockData;

        if (normalize) {
          finalData = DemoModeHelper.normalizeDemoData(finalData, matchedKey);
        }

        return of(new HttpResponse({ status: 200, body: finalData }));
      })
    );
  }

}

